var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34789 2.62979C4.34789 2.62979 5.56529 2.3335 8.00006 2.3335C10.4349 2.3335 11.6522 2.62979 11.6522 2.62979C11.6522 2.62979 13.2539 3.53936 14.7071 4.75003C14.8976 4.9087 15.0172 5.1369 15.0017 5.38433C14.9714 5.86963 14.8125 6.75123 14.1296 7.65716C13.9526 7.89193 13.6313 7.94906 13.3702 7.81386C13.038 7.64186 12.5544 7.38346 12.0468 7.08523C12.1183 8.8577 12.2584 10.8142 12.4962 13.1183C12.5498 13.6372 12.1984 14.1053 11.6797 14.1608C10.9203 14.2421 9.69039 14.3335 8.00006 14.3335C6.30973 14.3335 5.07986 14.2421 4.32039 14.1608C3.80173 14.1053 3.45033 13.6372 3.50389 13.1183C3.74176 10.8142 3.88179 8.8577 3.95333 7.08523C3.44569 7.38346 2.96209 7.64186 2.62993 7.81386C2.36887 7.94906 2.04751 7.89193 1.87053 7.65716C1.18759 6.75123 1.02868 5.86963 0.998406 5.38433C0.982973 5.1369 1.1025 4.9087 1.29299 4.75003C2.74627 3.53936 4.34789 2.62979 4.34789 2.62979Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98323 2.40629C9.9943 2.49145 10 2.57828 10 2.66645C10 3.771 9.10457 4.66643 8 4.66643C6.89543 4.66643 6 3.771 6 2.66645C6 2.57827 6.0057 2.49142 6.01677 2.40625",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.1fc3eddde63d0936dcdfb0b9f0329787.svg";
export { ForwardRef as ReactComponent };